<template>
    <section class="widget widget-txt" v-html="content">
    </section>
</template>

<script>
	import * as CONST from '../../utils/constants';

	export default {
		data: function () {
			return {
				content: CONST.globalProject.Hero.Content,
			}
		}
    }
</script>